import { useApplication } from "@/context/app";
import { For, onMount } from "solid-js";
import { useParams } from "@solidjs/router";
import { SelectInput } from "../../components/ui/form/SelectInput";
import { ComboBoxInput } from "../../components/ui/form/ComboBoxInput";
import { TextInput } from "../../components/ui/form/TextInput";
import { TextAreaInput } from "../../components/ui/form/TextAreaInput";
import { NumberInput } from "../../components/ui/form/NumberInput";
import {
  Card,
  CardContent,
  CardHeader,
  CardDescription,
  CardTitle
} from "@/components/shadcn/card";
import { LoadingButton } from "@/components/ui/Button";
import ImageUploader from "@/components/ui/ImageUploader";;
import useTherapyForm from "../../services/useTherapyForm";

export default function ManagerForm() {

  const { setBreadcrumb } = useApplication();

  const {
    form,
    handleInput,
    handleChange,
    handleSave,
    fetchInfo,
    loading
  } = useTherapyForm();

  const params = useParams();
  if (params.key !== undefined && params.key !== null) {
    fetchInfo(params.key);
  }

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Therapy',
        link: '/therapies'
      },
      {
        name: params.key !== undefined && params.key !== null ? 'Edit' : 'Create',
        current: true
      }
    ]);
  });

  return (
    <div className="main-card">
      <form autocomplete="off">
        <div class="grid grid-cols-12 gap-2">
          <Card class="lg:col-span-12 col-span-12">
            <CardHeader>
              <CardTitle>Basic Information</CardTitle>
            </CardHeader>
            <CardContent>
              <div class="grid grid-cols-8 gap-2">
                <div class="form-group col-span-4">
                  <TextInput
                    label="Name"
                    name="name"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <NumberInput
                    label="Duration (in weeks)"
                    name="duration"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <TextAreaInput
                    label="Description"
                    name="description"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <TextAreaInput
                    label="Target Conditions"
                    name="targetConditions"
                    form={form}
                    input={handleChange}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div class="text-end mt-3">
          <LoadingButton loading={loading()} onClick={handleSave}>Save</LoadingButton>
        </div>
      </form>
    </div>
  );
}
